import React from 'react'
import './Features.css'
import gif6 from '../Images/features/g6.gif'

const Feature6=() =>{
  return (
    <div>
      <div class="container">
       
            <div class="column-33">
                <img  src="https://i.pinimg.com/originals/e5/7a/19/e57a19d66d954557be26bcfd7b2201b8.gif" alt="" width="305" height="400" />
            </div>
            <div class="column-66">
                <h1 class="head"><b>Security and Privacy</b></h1>
                <p class="para"> Ensure strong security measures are in place to protect user data and prevent
                    unauthorized access, including secure login and authentication, encryption of sensitive data, and
                    regular data backups.
                </p>
            </div>
        </div>
    
    </div>
  )
}
export default  Feature6;